import React from 'react';
import { isMadPawsStore } from '../../../common/util';

const Cycle = () => (
  <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.9666 2.96685V0.70459L3.95185 3.72094L6.9666 6.73769V4.47503C9.46529 4.47503 11.4887 6.50006 11.4887 8.99995C11.4887 9.76524 11.2967 10.4817 10.9651 11.1154L12.0652 12.2163C12.6493 11.281 12.9961 10.1837 12.9961 8.99995C12.9961 5.66676 10.2978 2.96685 6.9666 2.96685ZM6.9666 13.5245C4.46831 13.5245 2.44447 11.4998 2.44447 8.99995C2.44447 8.23426 2.6369 7.51818 2.96853 6.8845L1.86801 5.78358C1.28394 6.71848 0.9375 7.81581 0.9375 8.99995C0.9375 12.3331 3.63541 15.033 6.9666 15.033V17.2953L9.98135 14.2786L6.9666 11.2622V13.5245Z"
      fill={isMadPawsStore() ? 'var(--primary-light-1x)' : '#2291B8'}
    />
  </svg>
);

export default Cycle;
